module.exports = __webpack_public_path__ + "media/assets/illustrations/resume-thumbnail-e8fa3f23bdfe3884b71ff35aae2e1b94.svg";